import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { GetState, Subscribe } from '../state/createState';
import { ControllerProps } from '../controller';
import { WidgetViewModel } from './viewModel';
import { subscribeToAgendaViewModel } from './agendaViewModel/agendaViewModel';
import { subscribeToTimeZoneViewModel } from './timeZoneViewModel/timeZoneViewModel';
import { subscribeToDatePickerViewModel } from './datePickerViewModel/datePickerViewModel';
import { subscribeToInitialLoaderViewModel } from './initialLoaderViewModel/initialLoaderViewModel';
import { subscribeToLoadMoreViewModel } from './loadMoreViewModel/loadMoreViewModel';
import { subscribeToFiltersViewModel } from './filtersViewModel/filtersViewModel';
import { DailyAgendaBiLogger } from '../../../utils/bi/biLogger';
import { subscribeToDialogViewModel } from './dialogViewModel/dialogViewModel';

export type SetViewModel = (partialViewModel: Partial<WidgetViewModel>) => void;
export type ViewModelSubscription = (args: {
  subscribe: Subscribe;
  setViewModel: SetViewModel;
  flowAPI: ControllerFlowAPI;
  getState: GetState;
  biLogger: DailyAgendaBiLogger;
}) => void;

export const initViewModelSubscriptions = ({
  flowAPI,
  getState,
  viewModel,
  subscribe,
  setProps,
  biLogger,
}: {
  flowAPI: ControllerFlowAPI;
  getState: GetState;
  viewModel: WidgetViewModel;
  subscribe: Subscribe;
  setProps: (props: ControllerProps) => void;
  biLogger: DailyAgendaBiLogger;
}) => {
  const setViewModel: SetViewModel = (partialViewModel) => {
    Object.assign(viewModel, partialViewModel);
    setProps({ viewModel: { ...viewModel } });
  };

  const args = {
    subscribe,
    setViewModel,
    flowAPI,
    getState,
    biLogger,
  };

  subscribeToInitialLoaderViewModel(args);
  subscribeToAgendaViewModel(args);
  subscribeToDialogViewModel(args);
  subscribeToTimeZoneViewModel(args);
  subscribeToDatePickerViewModel(args);
  subscribeToLoadMoreViewModel(args);
  subscribeToFiltersViewModel(args);
};
